import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LogService } from '../../shared/log/log.service';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'pioneer-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  email: string;
  password: string;

  constructor(public router: Router,
              public authenticationStore: AuthenticationStore,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService,
              private translateService: TranslateService) {
    logService.debug('LoginComponent constructor');
  }

  ngOnInit() {
  }

  onLogin(): Observable<boolean> {
    if (this.email == null || this.password == null) {
      this.flashMessagesService.error('MESSAGES.VALIDATION.ALL_FIELDS_REQUIRED', 'Login Error: email and password fields required');
      return;
    }
    const obs = this.authenticationStore.login(this.email, this.password);
    obs.subscribe(
      loginSuccess => this.router.navigate([ '/' ]),
      error => {
        this.flashMessagesService.error('LOGIN.CREDENTIALS_INVALID', 'Login Error: ' + error);
      }
    );
    return obs;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/login/login.component.ts